export default "/**\n * Additional functions for page scripts\n */\n;(function() {\n  // nothing yet\n})()\n";